 
 import { FormControl, MenuItem, Paper, Select } from "@mui/material";
import React from "react";

const AlertFilter = ({ filters, setFilters }) => {
  const paperStyle = {
    p: "0px 3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "260px",
    boxShadow: "none",
    backgroundColor: "#fff",
    // height: "32px",
    border: "1px solid #E4E4E4",
    borderRadius: "20px",
    // marginRight: "10px",
  };
  const titleStyle = {
    color: "#404040",
    fontSize: "12px",
  };
  const formControlStyle = {
    minWidth: 90,
    // height: "28px",
    backgroundColor: "fff",
    color: "#404040",
    border: "none",
  };

  const selectStyle = {
    // height: "28px",
    color: "#404040",
    fontSize: "12px",
    border: "none",
  };
  const menuItemStyle = {
    color: "#404040",
    fontSize: "12px",
  };
  return (
    <Paper sx={paperStyle}>
      <div style={titleStyle}>Filter Prediction :</div>
      <FormControl sx={formControlStyle} variant="standard">
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={filters}
          onChange={(e) => {
            setFilters(e.target.value);
          }}
          sx={selectStyle}
          disableUnderline
        >
          <MenuItem sx={menuItemStyle} value={"All"}>
            All
          </MenuItem>
          <MenuItem sx={menuItemStyle} value={"Limit Breached"}>
            Limit Breached
          </MenuItem>
          <MenuItem sx={menuItemStyle} value={"Prediction"}>
            Suspicious
          </MenuItem>
        </Select>
      </FormControl>
    </Paper>
  );
};

export default AlertFilter;
